import { render, staticRenderFns } from "./ModrAdd.vue?vue&type=template&id=0d9fb011&scoped=true&"
import script from "./ModrAdd.vue?vue&type=script&lang=js&"
export * from "./ModrAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9fb011",
  null
  
)

export default component.exports